import { utils } from "../../core/helpers/utils";
import { middlewareService } from "../../shared/service";

export const userService = {
 getUserData,
 getPanOnboardingStage,
 getUserProfile,
 getValidPans,
 getUserDashboardData,
 setDefaultPan,
 setRiskProfile,
 getUserStates
};
function getUserDashboardData(currentPan) {
    var promises = [];
    promises.push(getUserProfile());
    
    return Promise
      .all(promises)
      .then(function(response) {
        var allDetails = {
          userDetails: response[0],
        }
        return allDetails;
      })
      .catch(function(error) {
        console.log(error);
      });
}
function getUserData(currentPan) {
  var promises = [];
  promises.push(getUserProfile());
  promises.push(getValidPans(currentPan && currentPan.length > 0));
  promises.push(getPanOnboardingStage(currentPan));

  return Promise
    .all(promises)
    .then(function(response) {
      var allDetails = {
        userDetails: response[0],
        validPans: response[1].pansResponse
      }

      /**
       /* Updated onboarding logic due to /getOnboardingStageNew update on 07/05/2019
          with new key isAccountReady for visibility of red band
       */
      // if(response[1].onboardingStageResponse) {
      //   allDetails['panOnboardingStage'] = response[1].onboardingStageResponse.stage;
      //   allDetails['isOnboarded'] = response[1].onboardingStageResponse.stage === 'onboardingComplete' || response[1].onboardingStageResponse.stage === 'OnboardingComplete';
      // } else {
        allDetails['panOnboardingStage'] = response[2].stage;
        // allDetails['isOnboarded'] = response[2].stage === 'onboardingComplete' || response[2].stage === 'OnboardingComplete';
        allDetails['isOnboarded'] = response[2].isAccountReady;
      // }

      return allDetails;
    })
    .catch(function(error) {
      console.log(error);
    });
}

function getUserProfile() {
  const payload = {
    isAjax: true
  };

  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/profile', requestOptions)
    .then(response => response.json())
    .then(result => {
      const portfolioResponse = utils.parsePayload(result);

      return portfolioResponse;
    });
}

function getPanOnboardingStage(pan) {

  const payload = {
    isAjax: true,
    pan: pan
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/getOnboardingStageNew', requestOptions)
    .then(response => response.json())
    .then(result => {
      const onboardingStage = utils.parsePayload(result);

      return onboardingStage;
    })
    .catch(error => {
      console.log(error);
      // throw Error({
      //   test: 'adasasdas'
      // });
    });
}

function getValidPans(fetchOnboardingStage) {
  var responsePayload = {};

  var payload = {
    isAjax: true,
    platform : 'web',
    source : 'iosApp'
  }
  
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/getvalidpans', requestOptions)
    .then(response => response.json())
    .then(result => {
      const pansResponse = utils.parsePayload(result);

      responsePayload['pansResponse'] = pansResponse;

      if(fetchOnboardingStage) {
        return getPanOnboardingStage(pansResponse.default)
                .then(onboardingStageResponse => {
                  responsePayload['onboardingStageResponse'] = onboardingStageResponse;

                  return responsePayload;
                });
      } else {
        return responsePayload;
      }
    });
}

function setDefaultPan(pan) {
  var payload = {
    isAjax: true,
    pan: pan
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/setpandefault', requestOptions)
    .then(response => response.json())
    .then(result => {
      const defaultPanResponse = utils.parsePayload(result);

      return defaultPanResponse;
    });
}

function setRiskProfile(payload) {
  let url = "/users/risk";
  return middlewareService.postApiData(url, payload)
}

function getUserStates(email, checkpoints, currentStatus, pan) {
  let url = "/stats/checkpoints/status";
  let payload = {
    payload: utils.encryptedPayload({
      "email": email,
      "checkpoints": checkpoints,
      "pan": pan,
      "path": currentStatus
    })
  };
  return middlewareService.postApiData(url, utils.getPKey() ? payload : payload.payload)
}